import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { translateText, useFormController } from '@dreryk/react-common';
import { EmailAddressInput, StyledFlex } from '@dreryk/react-components';

import { educationalMaterialsTranslationKeys as t } from '../translations';

import {
   EducationalMaterialShareFormBean,
   EducationalMaterialShareFormController,
} from './EducationalMaterialShareForm.types';

type EducationalMaterialShareFormRenderProps = Pick<EducationalMaterialShareFormController, 'handleSubmit' | 'trigger'>;

type EducationalMaterialShareFormProps = Readonly<{
   children: (renderProps: EducationalMaterialShareFormRenderProps) => JSX.Element;
   patientEmail: VisitPatient['emailAddress'];
}>;

export const EducationalMaterialShareForm = (props: EducationalMaterialShareFormProps): JSX.Element => {
   const { register, handleSubmit, trigger } = useFormController<EducationalMaterialShareFormBean>({
      emailAddress: props.patientEmail ?? null,
   });

   return (
      <StyledFlex as={'form'} noValidate gap={16} direction={'column'}>
         <EmailAddressInput
            controller={register('emailAddress', {
               required: true,
            })}
            testId={'emailAddress'}
            label={t.share.email}
            placeholder={translateText(t.share.fillPatientEmail)}
         />

         {props.children({
            trigger: trigger,
            handleSubmit: handleSubmit,
         })}
      </StyledFlex>
   );
};
